function compareByParking(a, b) {
  if (a.parking === null) {
    return 1
  }

  if (b.parking === null) {
    return -1
  }
}

function compareByParkingName(a, b)
{
  return a.parking?.name.localeCompare(b.parking?.name)
}

function compareByTrailerName(a, b)
{
  return a.plateNumber.localeCompare(b.plateNumber)
}

export { compareByParking, compareByParkingName, compareByTrailerName }
